const blockInvalidNumberChars = event => {
  if (['e', 'E', '+', '-', '.', ','].includes(event.key)) {
    event.preventDefault();
  }
};

export default blockInvalidNumberChars;
